import dynamic from 'next/dynamic';
import React from 'react';
const Registration = dynamic(() => import('@/components/Registration'), {
  ssr: false,
});

const RegistrationPage = () => {
  return <Registration />;
};
export default RegistrationPage;
